import React from 'react';
import '../styles/AboutSection.css';
import aboutImg from '../assets/images/aboutpage.jpeg';

const AboutSection = () => (
  <div className="about-main-section">
    <div className="about-img-side">
      <img className="about-main-img" src={aboutImg} alt="About" />
      <div className="about-stats-wrap">
        <div className="about-stats-row">
          <div className="about-stat about-stat-blue">
            <span className="about-stat-value">25</span>
            <span className="about-stat-label">Years Experience</span>
          </div>
          <div className="about-stat about-stat-red">
            <span className="about-stat-value">100+</span>
            <span className="about-stat-label">Profesional Team</span>
          </div>
        </div>
        <div className="about-stats-row">
          <div className="about-stat about-stat-blue">
            <span className="about-stat-value">150</span>
            <span className="about-stat-label">Areas Coverage</span>
          </div>
          <div className="about-stat about-stat-red">
            <span className="about-stat-value">10K</span>
            <span className="about-stat-label">Succeeded Project</span>
          </div>
        </div>
      </div>
    </div>
    <div className="about-content-side">
      <div className="about-welcome">
        <span className="about-welcome-icon">⚡</span>
        <span className="about-welcome-text">WELCOME TO</span>
      </div>
      <h1 className="about-title">AGR Consultant & Engineers</h1>
      <div className="about-desc">
        At AGR Consultant & Engineers, we are your premier destination for comprehensive electrical solutions. With a commitment to excellence and a passion for innovation, we offer a wide range of services tailored to meet your specific needs. Our vision is to lead the industry by setting new standards for excellence, reliability, and customer satisfaction.
      </div>
      <div className="about-desc">
        From sales and servicing of Air Circuit Breakers (ACBs), Vacuum Circuit Breakers (VCBs), and Molded Case Circuit Breakers (MCCBs) to electrical installation, CT & PT calibration, and switchgears & spare parts, we cover all aspects of the electrical sector. Our team of skilled electricians ensures seamless installations, efficient maintenance, and reliable repairs to keep your systems running smoothly.
      </div>
      <div className="about-desc">
        We pride ourselves on providing dependable service at affordable prices, maximizing value for your investment. Our professional technicians are dedicated to delivering top-notch service and satisfaction, ensuring a worry-free experience for our customers.
      </div>
      <div className="about-desc">
        Whether you’re looking for LT/HT electrical panel design and installation or LT/HT protection relay sales and installation, we have the expertise and experience to meet your needs. Trust AGR Consultant & Engineers for all your electrical requirements and experience excellence at every step.
      </div>
    </div>
  </div>
);

export default AboutSection;
